import actionTypes from '../constants/actionTypes/loading-action-types';

const initialState = {
    isLoading: false,
    counter: 0
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.INCREMENT_LOADING_COUNTER:
            return { isLoading: true, counter: state.counter + 1 };
        case actionTypes.DECREMENT_LOADING_COUNTER:
            let isLoading = state.counter - 1 > 0;
            return {
                isLoading,
                counter: state.counter - 1 <= 0 ? 0 : state.counter - 1
            };
        default:
            return state;
    }
};

export default reducer;
